import { hashString } from './hashString';
export const createUniqueClassName = (block, elementName) => {
    const hash = hashString('universal-nav' + block + elementName);
    return `${block}__${elementName}-${hash}`;
};
//# sourceMappingURL=createUniqueClassName.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
